const STATIC_PATHS_ENDPOINT = "/__astro_static_paths";
const PRERENDER_ENDPOINT = "/__astro_prerender";
const STATIC_IMAGES_ENDPOINT = "/__astro_static_images";
export {
  PRERENDER_ENDPOINT,
  STATIC_IMAGES_ENDPOINT,
  STATIC_PATHS_ENDPOINT
};
